<template>
  <div class="container">
    <h1 class="py-4">アプリユーザデータ</h1>
    <div class="pb-4">
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="l-pid">アプリユーザID</label><br />
          <input
            v-model="applicationUserId"
            placeholder="アプリユーザID"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">携帯電話番号</label><br />
          <input
            v-model="mobile"
            placeholder="携帯電話番号"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">メールアドルレス</label><br />
          <input
            v-model="mail"
            placeholder="メールアドルレス"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">popinfoId</label><br />
          <input
            v-model="popinfoId"
            placeholder="popinfoId"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">メール通知</label><br />
          <select v-model="mailNotifications" class="input-boot">
            <option
              v-for="option in this.notificationOptions"
              :value="option.value"
              :key="option.value"
            >
              {{ option.display }}
            </option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">PUSH通知</label><br />
          <select v-model="pushNotifications" class="input-boot">
            <option
              v-for="option in this.notificationOptions"
              :value="option.value"
              :key="option.value"
            >
              {{ option.display }}
            </option>
          </select>
        </div>
      </div>
      <div class="text-right">
        <button class="btn btn-primary mr10" @click="clear">クリア</button>
        <button class="btn btn-primary" @click="search">検索</button>
      </div>
      <div class="form-row">
        <div class="form-group col-md-auto">
          <input type="file" id="csvUpload" hidden />
          <button disabled class="btn btn-primary">
            CSV インポート
          </button>
        </div>
        <div class="form-group col-md-auto">
          <vue-json-to-csv
            :labels="this.csvCurrentFields"
            :json-data="this.csvData"
            :csv-title="this.fileName"
          >
            <button class="btn btn-success">
              CSV ダウンロード
            </button>
          </vue-json-to-csv>
        </div>
      </div>
    </div>
    <div :key="key">
      <div v-if="loading" class="form-row">
        <b-spinner
          class="autoMarginLR"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </div>
      <div v-if="!loading" class="table-responsive">
        <b-table
          id="dataTable"
          :items="tableData"
          :per-page="perPage"
          :current-page="currentPage"
          small
        >
          <template #cell(アプリユーザID)="data">
            <router-link
              :to="{
                name: 'ApplicationUserDataDetails',
                query: { applicationUserId: data.item.アプリユーザID },
              }"
              target="_blank"
              >{{ data.item.アプリユーザID }}</router-link
            >
          </template>
        </b-table>
        <b-pagination
          class="mt30"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="dataTable"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";
import VueJsonToCsv from "vue-json-to-csv";
import prefs from "@/constants/PrefsEnum";
import countries from "@/constants/CountriesEnum";

export default {
  name: "ApplicationUserData",
  mixins: [utils, master, prefs, countries],
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  watch: {
    /*     currentPage(value) {
      sessionStorage.currentPage = value;
    }, */
  },
  data() {
    return {
      csvCurrentFields: {},
      currentPage: 1,
      perPage: 10,
      fileName: "",
      labels: [],
      loading: true,
      tableData: [],
      csvData: [],
      db: firebase.firestore(),
      applicationUserId: "",
      popinfoId: "",
      mobile: "",
      mail: "",
      mailNotifications: "",
      pushNotifications: "",
      key: 0,
    };
  },
  components: {
    VueJsonToCsv,
  },
  created: function() {
    this.labels = this.tsvFormat.bankitInfo.labels;
    this.loadCollection();
  },
  methods: {
    orderByContractNumber(a, b) {
      if (a.契約番号 > b.契約番号) {
        return 1;
      } else if (a.契約番号 < b.契約番号) {
        return -1;
      }
      return 0;
    },
    init() {
      this.tableData = [];
      this.csvData = [];
      this.key = this.key ? 0 : 1;
    },
    englishField(fieldNameJp) {
      return this.fields[fieldNameJp];
    },
    clear() {
      this.applicationUserId = "";
      this.mail = "";
      this.mobile = "";
      this.popinfoId = "";
      this.mailNotifications = "";
      this.pushNotifications = "";
      this.loadCollection();
    },
    search() {
      let searchParams = {
        application_user_id: this.applicationUserId,
        mail_address: this.mail,
        mobile: this.mobile,
        popinfoID: this.popinfoId,
        receive_mail: this.mailNotifications,
        receive_notif: this.pushNotifications,
      };
      this.loadCollection(searchParams);
    },
    loadCollection(searchParams = null) {
      this.init();
      this.loading = true;
      let query = this.db.collection("applicationUsers");
      if (searchParams !== null) {
        for (const [key, value] of Object.entries(searchParams)) {
          if (value !== "") {
            query = query.where(key, "==", value);
          }
        }
      }
      //query.orderBy("contract_number", "asc");
      this.fileName = this.tsvFormat.applicationUserData.fileName;
      this.csvCurrentFields = this.tsvFormat.applicationUserData.labels;
      query
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            if (doc.exists) {
              var data = doc.data();
              let displayData = {
                アプリユーザID: data.application_user_id,
                携帯電話番号: data.mobile,
                メールアドレス: data.mail_address,
                POPINFOID: data.popinfoID,
                メール通知: data.receive_mail,
                PUSH通知: data.receive_notif,
              };
              let notifMailText = this.notificationOptions.find((e) => {
                return e.value == data.receive_mail;
              });
              if (notifMailText !== undefined) {
                displayData.メール通知 = notifMailText.display;
              }
              
              let notifPushText = this.notificationOptions.find((e) => {
                return e.value == data.receive_notif;
              });
              if (notifPushText !== undefined) {
                displayData.PUSH通知 = notifPushText.display;
              }


              this.tableData.push(displayData);
              this.csvData.push(data);
            }
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};

/* メール通知: this.notificationOptions.find((e) => {
                  return e.value.trim() == data.receive_mail.trim();
                }).display,
                PUSH通知: this.notificationOptions.find((e) => {
                  return e.value.trim() == data.receive_notif.trim();
                }).display, */
</script>
